export const API_BASE_URL = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_LIVE_BASE_URL : process.env.REACT_APP_LIVE_BASE_URL_DEV;
export const API_BASE_URL_V2 = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_LIVE_BASE_URL_V2 : process.env.REACT_APP_LIVE_BASE_URL_DEV_V2;
export const SERVICES_API = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_SERVICE_API : process.env.REACT_APP_SERVICE_API_DEV;

// export const API_BASE_URL = "http://69.167.152.165:3005/v1/";
export const RECURLY_PUBLIC_KEY = process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_RECURLY_PUBLIC_KEY : process.env.REACT_APP_RECURLY_PUBLIC_KEY_DEV;

export const monthMap = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sep",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const weeks = ["", "SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
export const programLevels = ["", "BEGINNER", "MODERATE", "ADVANCED"];

export const validations = {
  usernameRegex: /^[a-z0-9A-Z_.]+$/,
  passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/,
  emailRegex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  postalCodeRegex: /^\d{5}(-\d{4})?$/,
  usernameValidation: "Username should not be empty",
  firstnameValidation: "First name should not be empty",
  GenderValidation: "Please select gender",
  lastnameValidation: "Last name should not be empty",
  postalcodeValidation: "Postal code should not be empty",
  emailValidation: "Email should not be empty",
  userNameLengthValidation: "Username must contain atleast 2 characters",
  firstNameLengthValidation: "First name must contain atleast 2 characters",
  lastNameLengthValidation: "Last name must contain atleast 2 characters",
  postalcodeLengthValidation: "Postal code must be atleast 5 characters",
  usernameRegexValidation: "Username should not contain special characters",
  passwordValidation: "Password should not be empty",
  passwordRegexValidation:
    "Password must contain atleast one special character,one uppercase letter,one number and minimum 6 characters long.",
  emailRegexValidation: "Email is invalid",
  passwordMatchValidation: "Both passwords must match",
};

export const calculateDateFromTrialPeriod = (trialdays, unit) => {
  let newDate;
  if (unit === "months") {
    var d = new Date();

    newDate = d.setMonth(d.getMonth() + trialdays);
  } else {
    newDate = new Date(new Date().getTime() + trialdays * 24 * 60 * 60 * 1000);
  }
  var newFormattedDate = new Date(newDate);
  var today = new Date();
  var date =
    newFormattedDate.getDate() +
    "/" +
    (newFormattedDate.getMonth() + 1) +
    "/" +
    today.getFullYear();
  return date;
};

export const calculateDateFromTrialPeriodFormat = (trialdays, unit) => {
  let newDate;
  if (unit === "months") {
    var d = new Date();
    newDate = d.setMonth(d.getMonth() + trialdays);
  } else {
    newDate = new Date(new Date().getTime() + trialdays * 24 * 60 * 60 * 1000);
  }
  var newFormattedDate = new Date(newDate);

  var today = new Date();
  var date =
    newFormattedDate.toLocaleString("default", { month: "long" }) +
    " " +
    newFormattedDate.getDate() +
    ", " +
    today.getFullYear();
  return date;
};

export const convertCurrencySymbols = (currencyName) => {
  var currency_symbols = {
    USD: "$", // US Dollar
    EUR: "€", // Euro
    CRC: "₡", // Costa Rican Colón
    GBP: "£", // British Pound Sterling
    ILS: "₪", // Israeli New Sheqel
    INR: "₹", // Indian Rupee
    JPY: "¥", // Japanese Yen
    KRW: "₩", // South Korean Won
    NGN: "₦", // Nigerian Naira
    PHP: "₱", // Philippine Peso
    PLN: "zł", // Polish Zloty
    PYG: "₲", // Paraguayan Guarani
    THB: "฿", // Thai Baht
    UAH: "₴", // Ukrainian Hryvnia
    VND: "₫", // Vietnamese Dong
  };

  // var currency_name = "INR";

  if (currency_symbols[currencyName] !== undefined) {
    return currency_symbols[currencyName];
  }
};

export const getDateFormat = (date) => {
  var newFormattedDate = new Date(date);
  var date =
    newFormattedDate.getFullYear() +
    "-" +
    (newFormattedDate.getMonth() + 1) +
    "-" +
    newFormattedDate.getDate();

  return date;
};

export const imageURLDebug = "http://192.168.1.68:3000";
export const imageURLLive = "https://app.indimoves.com";

export const calculateWatchedDuration = (video_time, duration_watched) => {
  let video_time_in_secs = video_time || 1;
  return ((duration_watched * 100) / video_time_in_secs).toFixed("2");
};
export const FAVORITE_DEFAULT_COUNT = 10;

export const genders = {
  Male: "MALE",
  Female: "FEMALE",
  M: "MALE",
  F: "FEMALE",
  GNL: "GENDER NOT LISTED",
  PNTS: "PREFER NOT TO SAY",
  O: "OTHERS",
}